import { EntityItem } from "../../entity/EntityItem";

export class DtoItemsDeleteRes extends EntityItem {
  public message: string | null = null;
}
